import React, { useEffect, useState, useMemo } from 'react';
import styled from 'styled-components';
import Menu from '../menu/Menu';
import Header from '../cabecalho/Cabecalho';
import PontosService from '../../service/pontos';
import RegioesService from '../../service/regioes';
import UsuariosService from '../../service/usuario';
import Botao from '../botao/Botao';
import Titulo from '../titulo/Titulo';
import { intervalosDoPonto } from '../designacoes/horariosPonto';

const comIntervalos = (p) => ({ ...p, intervalosDeHorario: intervalosDoPonto(p) });

const FAIXAS_PADRAO = {
  'Manhã': [['06:00', '08:00'], ['08:00', '10:00'], ['10:00', '12:00']],
  'Tarde': [['12:00', '14:00'], ['14:00', '16:00'], ['16:00', '18:00']],
  'Noite': [['18:00', '20:00'], ['20:00', '22:00']]
};

const periodoDaFaixa = (f) => {
  const h = parseInt((f.horarioInicial || '0').slice(0, 2), 10);
  if (h < 12) return 'Manhã';
  if (h < 18) return 'Tarde';
  return 'Noite';
};

const ordenarFaixas = (lista) =>
  [...lista].sort((a, b) => (a.horarioInicial || '').localeCompare(b.horarioInicial || ''));

const faixasInvalidas = (lista) =>
  lista.some(f => !f.horarioInicial || !f.horarioFinal || f.horarioInicial >= f.horarioFinal);

const ToastContainer = styled.div`
  position: fixed;
  top: 100px;
  right: 20px;
  z-index: 9999;
`;

const ToastMessage = styled.div`
  background-color: ${props => props.type === 'error' ? '#f44336' : '#4caf50'};
  color: white;
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  margin-bottom: 10px;
  min-width: 250px;
  opacity: ${props => props.show ? 1 : 0};
  transition: opacity 0.3s ease-in-out;
  pointer-events: none;
`;

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
`;

const MainContentWrapper = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  min-height: 0;
  margin-top: 85px;
  margin-bottom: 50px;

  @media (max-width: 767px) {
    margin-bottom: 0;
  }
`;

const Container = styled.div`
  flex: 1;
  overflow-y: auto;
  margin-left: 260px;
  padding: 20px 32px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 18px;

  @media (max-width: 1200px) and (min-width: 768px) {
    margin-left: 60px;
    padding: 20px;
  }

  @media (max-width: 767px) {
    margin-left: 0;
    padding: 16px;
  }
`;

const ControlsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
`;

const SearchInput = styled.input`
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  width: 300px;
  max-width: 100%;
`;

const TableWrapper = styled.div`
  flex: 1;
  background-color: white;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: auto;
  min-height: 0;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const Th = styled.th`
  background-color: #008080;
  color: white;
  padding: 12px 10px;
  text-align: left;
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 10;
`;

const Td = styled.td`
  padding: 10px;
  border-bottom: 1px solid #eee;
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  vertical-align: top;
`;

const Input = styled.input`
  width: 100%;
  padding: 6px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 13px;
  box-sizing: border-box;
`;

const Select = styled.select`
  width: 100%;
  padding: 6px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 13px;
  box-sizing: border-box;
`;

const MultiSelectContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

const Tag = styled.span`
  background-color: #e0f2f1;
  color: #00695c;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;

const AddButton = styled.button`
  background: none;
  border: none;
  color: #008080;
  cursor: pointer;
  font-size: 12px;
  padding: 2px;
  &:hover { text-decoration: underline; }
`;

const ActionButton = styled.button`
  background-color: ${props => props.disabled ? '#ccc' : '#008080'};
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-size: 12px;
  width: 100%;
`;

const CancelButton = styled.button`
  background-color: #d9534f;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  width: 100%;
  &:hover {
    background-color: #c9302c;
  }
`;

const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 6px 8px;
  border-radius: 4px;
  background-color: ${props => props.$scheduled ? '#fff3cd' : '#f8d7da'};
  color: ${props => props.$scheduled ? '#856404' : '#721c24'};
  font-size: 11px;
  cursor: default;
  text-align: center;
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 500px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 15px;

  input[type='datetime-local'] {
    font-family: inherit;
    font-size: 14px;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

const ModalTitle = styled.h3`
  margin: 0;
  color: #008080;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #666;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Label = styled.label`
  font-size: 13px;
  font-weight: 500;
  color: #333;
`;

const ModalQuestion = styled(Label)`
  font-size: 14px;
  font-weight: 500;
`;

const RadioOption = styled.label`
  display: flex;
  align-items: center;
  gap:6px;
  font-size:14px;
  line-height: 1.4;
  color: #333;
  
  input {
    margin: 0;
  }
`;

const HelperText = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: #666;
`;

const SummaryDetails = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
  display: flex;
  flex-direction: column;
  gap: 8px;

  p {
    margin: 0;
    font-weight: 400;
  }

  strong {
    font-weight: 600;
  }
  `;

const SearchableUserList = ({ users, selectedIds, onToggle, placeholder }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredUsers = users.filter(u => 
    u.nome.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
      <Input 
        placeholder={placeholder} 
        value={searchTerm} 
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ fontSize: '11px', padding: '4px', marginBottom: '4px' }}
      />
      <div style={{ maxHeight: '100px', overflowY: 'auto' }}>
        {filteredUsers.map(u => (
          <div key={u._id} style={{ fontSize: '11px' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <input 
                type="checkbox"
                checked={selectedIds.includes(u._id)}
                onChange={() => onToggle(u._id)}
              />
              {u.nome}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

const formatarHora = (hhmm = '') => {
  const [h, m] = hhmm.split(':');
  return `${Number(h)}h${m && m !== '00' ? m : ''}`;
};

const rotuloDaFaixa = (f) => `${formatarHora(f.horarioInicial)} - ${formatarHora(f.horarioFinal)}`;

const FaixasEditor = ({ faixas, onChange }) => {
  const [adicionando, setAdicionando] = useState(false);
  const [inicio, setInicio] = useState('');
  const [fim, setFim] = useState('');

  const remover = (i) => onChange(faixas.filter((_, idx) => idx !== i));

  const confirmar = () => {
    if (!inicio || !fim || inicio >= fim) return;
    const jaExiste = faixas.some(f => f.horarioInicial === inicio && f.horarioFinal === fim);
    if (!jaExiste) {
      onChange(ordenarFaixas([...faixas, { horarioInicial: inicio, horarioFinal: fim }]));
    }
    setInicio('');
    setFim('');
    setAdicionando(false);
  };

  return (
    <MultiSelectContainer>
      {faixas.map((f, i) => (
        <Tag key={`${f.horarioInicial}-${f.horarioFinal}`} onClick={() => remover(i)}>
          {rotuloDaFaixa(f)} &times;
        </Tag>
      ))}
      {adicionando ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <Input type="time" style={{ padding: '2px', width: '90px' }} value={inicio}
            onChange={e => setInicio(e.target.value)} />
          <span>-</span>
          <Input type="time" style={{ padding: '2px', width: '90px' }} value={fim}
            onChange={e => setFim(e.target.value)} />
          <AddButton type="button" onClick={confirmar}>OK</AddButton>
          <span onClick={() => setAdicionando(false)} style={{ cursor: 'pointer', color: '#666' }}>&times;</span>
        </div>
      ) : (
        <AddButton type="button" onClick={() => setAdicionando(true)}>+</AddButton>
      )}
    </MultiSelectContainer>
  );
};

const GerenciarPontos = () => {
  const [pontos, setPontos] = useState([]);
  const [regioes, setRegioes] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [editedRows, setEditedRows] = useState({}); // { id: { ...changes } }
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [pontoSelecionadoParaInativar, setPontoSelecionadoParaInativar] = useState(null);
  const [pontoSelecionadoParaAcao, setPontoSelecionadoParaAcao] = useState(null);
  const [etapaModalInativacao, setEtapaModalInativacao] = useState(null);
  const [tipoInativacao, setTipoInativacao] = useState(null);
  const [agendarReativacao, setAgendarReativacao] = useState(null);
  const [dataInativacao, setDataInativacao] = useState('');
  const [dataReativacao, setDataReativacao] = useState('');
  const [motivoInativacao, setMotivoInativacao] = useState('');
  const [newPonto, setNewPonto] = useState({
    nome: '',
    local: '',
    regiao: '',
    periodos: [],
    intervalosDeHorario: [],
    dias: [],
    coordenadores: []
  });

  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast(prev => ({ ...prev, show: false }));
    }, 3000);
  };

  const handleAbrirModalInativacao = (ponto) => {
    setPontoSelecionadoParaInativar(ponto);
    setEtapaModalInativacao('configuracao');
    setTipoInativacao(null);
    setAgendarReativacao(null);
    setDataInativacao('');
    setDataReativacao('');
    setMotivoInativacao('');
  };

  const handleFecharModalInativacao = () => {
    setPontoSelecionadoParaInativar (null);
    setEtapaModalInativacao(null);
    setTipoInativacao(null);
    setAgendarReativacao(null);
    setDataInativacao('');
    setDataReativacao('');
    setMotivoInativacao('');
  };

  const handleConfirmarInativacao = async () => {
    if (!pontoSelecionadoParaInativar) {
      showToast('Nenhum ponto foi selecionado para inativação.', 'error');
      return;
    }

    const dadosInativacao = {
      inatividadeEm: tipoInativacao === 'agendada' ? dataInativacao: undefined,
      reativacaoEm: agendarReativacao ? dataReativacao: undefined,
      motivoInativacao
    };

    try {
      const pontoAtualizado = await PontosService.inativarPonto(
        pontoSelecionadoParaInativar._id,
        dadosInativacao
      );

      setPontos(prev =>
        prev.map(ponto =>
          ponto._id === pontoAtualizado._id
            ? {...ponto, ...pontoAtualizado}
            : ponto
        )
      );

      const mensagem = tipoInativacao === 'agendada'
        ? 'Ponto com inativação agendada com sucesso.'
        : 'Ponto inativado com sucesso.';
      
        handleFecharModalInativacao();
        showToast(mensagem, 'success');
    } catch (error) {
      console.error('Erro ao inativar ponto:', error);
      showToast(error.message ||'Erro ao inativar ponto.', 'error');
    }
  };

  const handleConfirmarAcaoPonto = async () => {
    if (!pontoSelecionadoParaAcao) {
      showToast('Nenhum ponto foi selecionado para essa ação.', 'error');
      return;
    }

    const vaiCancelarAgendamento =
    pontoSelecionadoParaAcao.ativo !== false &&
    Boolean(pontoSelecionadoParaAcao.inatividadeAgendadaEm);

    try {
      const pontoAtualizado = await PontosService.reativarPonto(
        pontoSelecionadoParaAcao._id
      );

      setPontos(prev =>
        prev.map(ponto =>
          ponto._id === pontoAtualizado._id
            ? {...ponto, ...pontoAtualizado}
            : ponto
        )
      );

      setPontoSelecionadoParaAcao(null);

      showToast(
        vaiCancelarAgendamento
          ? 'Cancelamento do agendamento de inativação concluído com sucesso.'
          : 'Reativação de ponto concluída com sucesso',
        'success'
      );
    } catch (error) {
      console.error('Erro ao reativar ponto ou cancelar agendamento:', error);
      showToast(error.message || 'Não foi possível concluir a ação.', 'error');
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [pontosData, regioesData, usuariosData] = await Promise.all([
          PontosService.getPontos(true),
          RegioesService.getRegioes(),
          UsuariosService.getUsuarios()
        ]);
        setPontos((Array.isArray(pontosData) ? pontosData : (pontosData.pontos || [])).map(comIntervalos));
        setRegioes(Array.isArray(regioesData) ? regioesData : (regioesData.regioes || []));
        setUsuarios(usuariosData.usuarios || (Array.isArray(usuariosData) ? usuariosData : []));
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
        showToast("Erro ao carregar dados.", "error");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleCreatePonto = async () => {
    if (!newPonto.nome || !newPonto.local || !newPonto.regiao) {
      showToast("Preencha os campos obrigatórios (Nome, Local, Região)", "error");
      return;
    }
    if (faixasInvalidas(newPonto.intervalosDeHorario)) {
      showToast("Horário inicial deve ser menor que o final em todas as faixas", "error");
      return;
    }

    try {
      const createdPonto = await PontosService.createPonto(newPonto);
      setPontos(prev => [...prev, comIntervalos(createdPonto)]);
      setShowCreateModal(false);
      setNewPonto({
        nome: '',
        local: '',
        regiao: '',
        periodos: [],
        intervalosDeHorario: [],
        dias: [],
        coordenadores: []
      });
      showToast("Ponto criado com sucesso!", "success");
    } catch (error) {
      console.error("Erro ao criar ponto:", error);
      showToast("Erro ao criar ponto.", "error");
    }
  };

  const toggleNewPontoArrayItem = (field, item) => {
    setNewPonto(prev => {
      const currentList = prev[field] || [];
      let newList;
      if (currentList.includes(item)) {
        newList = currentList.filter(i => i !== item);
      } else {
        newList = [...currentList, item];
      }
      
      return { ...prev, [field]: newList };
    });
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleExport = () => {
    const headers = ["Nome", "Local", "Região", "Períodos", "Horários", "Dias", "Coordenadores", "Regional"];
    const csvContent = [
      headers.join(","),
      ...pontos.map(p => {
        const regiaoNome = p.regiao?.nome || '';
        const coords = p.coordenadores?.map(c => usuarios.find(u => u._id === c)?.nome || '').join("; ") || '';
        const regional = p.coordenadores?.find(c => {
            const u = usuarios.find(user => user._id === c);
            return u && u.perfil && u.perfil.includes('coordenador-regional');
        });
        const regionalNome = regional ? usuarios.find(u => u._id === regional)?.nome : '';
        
        return [
          `"${p.nome}"`,
          `"${p.local}"`,
          `"${regiaoNome}"`,
          `"${(p.periodos || []).join("; ")}"`,
          `"${(p.intervalosDeHorario || []).map(rotuloDaFaixa).join("; ")}"`,
          `"${(p.dias || []).join("; ")}"`,
          `"${coords}"`,
          `"${regionalNome}"`
        ].join(",");
      })
    ].join("\n");

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "pontos.csv");
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleChange = (id, field, value) => {
    setEditedRows(prev => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: value
      }
    }));
  };

  const handleSave = async (id) => {
    const changes = editedRows[id];
    if (!changes) return;

    if (changes.intervalosDeHorario && faixasInvalidas(changes.intervalosDeHorario)) {
      showToast("Horário inicial deve ser menor que o final em todas as faixas", "error");
      return;
    }

    try {
      const salvo = await PontosService.updatePonto(id, changes);
      setPontos(prev => prev.map(p => {
        if (p._id !== id) return p;
        const atualizado = { ...p, ...changes };
        if (changes.intervalosDeHorario) {
          // Reflete o que a API persistiu, para não exibir como salvo algo que não foi gravado.
          atualizado.intervalosDeHorario = salvo?.intervalosDeHorario ?? p.intervalosDeHorario;
          atualizado.horarios = salvo?.horarios ?? p.horarios;
        }
        return atualizado;
      }));
      setEditedRows(prev => {
        const newState = { ...prev };
        delete newState[id];
        return newState;
      });
      showToast("Ponto atualizado com sucesso!", "success");
    } catch (error) {
      console.error("Erro ao salvar ponto:", error);
      showToast("Erro ao salvar ponto.", "error");
    }
  };

  const handleCancel = (id) => {
    setEditedRows(prev => {
      const newState = { ...prev };
      delete newState[id];
      return newState;
    });
  };

  const getDisplayValue = (ponto, field) => {
    if (editedRows[ponto._id] && editedRows[ponto._id][field] !== undefined) {
      return editedRows[ponto._id][field];
    }
    return ponto[field];
  };

  const filteredPontos = useMemo(() => {
    if (!searchTerm) return pontos;
    const lowerTerm = searchTerm.toLowerCase();
    return pontos.filter(p => 
      p.nome.toLowerCase().includes(lowerTerm) ||
      p.local.toLowerCase().includes(lowerTerm) ||
      (p.regiao?.nome || '').toLowerCase().includes(lowerTerm)
    );
  }, [pontos, searchTerm]);



  const toggleArrayItem = (id, field, item) => {
    const ponto = pontos.find(p => p._id === id);
    const currentList = getDisplayValue(ponto, field) || [];
    let newList;
    if (currentList.includes(item)) {
      newList = currentList.filter(i => i !== item);

      if (field === 'periodos') {
        const atuais = getDisplayValue(ponto, 'intervalosDeHorario') || [];
        const restantes = atuais.filter(f => periodoDaFaixa(f) !== item);
        if (restantes.length !== atuais.length) {
          handleChange(id, 'intervalosDeHorario', restantes);
        }
      }
    } else {
      newList = [...currentList, item];

      if (field === 'periodos') {
        const atuais = getDisplayValue(ponto, 'intervalosDeHorario') || [];
        const novas = (FAIXAS_PADRAO[item] || [])
          .map(([horarioInicial, horarioFinal]) => ({ horarioInicial, horarioFinal }))
          .filter(n => !atuais.some(f => f.horarioInicial === n.horarioInicial && f.horarioFinal === n.horarioFinal));
        if (novas.length) {
          handleChange(id, 'intervalosDeHorario', ordenarFaixas([...atuais, ...novas]));
        }
      }
    }
    
    handleChange(id, field, newList);
  };

  return (
    <PageWrapper>
      <ToastContainer>
        <ToastMessage show={toast.show} type={toast.type}>
          {toast.message}
        </ToastMessage>
      </ToastContainer>
      <Header />
      <Menu />
      <MainContentWrapper>
        <Container>
          <Titulo>Gerenciar Pontos</Titulo>
          <ControlsContainer>
            <SearchInput  
              placeholder="Buscar por nome, local ou região..." 
              value={searchTerm}
              onChange={handleSearch}
            />
            <div style={{ display: 'flex', gap: '10px' }}>
              <Botao onClick={handleExport}>Exportar CSV</Botao>
              <Botao onClick={() => setShowCreateModal(true)} style={{ backgroundColor: '#008080' }}>Criar Ponto</Botao>
            </div>
          </ControlsContainer>
          
          <TableWrapper>
            <Table>
              <thead>
                <tr>
                  <Th style={{ width: '18%' }}>Nome</Th>
                  <Th style={{ width: '18%' }}>Local</Th>
                  <Th style={{ width: '8%' }}>Períodos</Th>
                  <Th style={{ width: '14%' }}>Horários</Th>
                  <Th style={{ width: '8%' }}>Dias</Th>
                  <Th style={{ width: '10%' }}>Região</Th>
                  <Th style={{ width: '10%' }}>Coordenadores</Th>
                  <Th style={{ width: '10%' }}>Regional</Th>
                  <Th style={{ width: '10%' }}>Secretárias</Th>
                  <Th style={{ width: '4%' }}>Ação</Th>
                </tr>
              </thead>
              <tbody>
                {filteredPontos.map(p => {
                  const isEdited = !!editedRows[p._id];
                  const temInativacaoAgendada = Boolean(p.inatividadeAgendadaEm);
                  const estaInativo = p.ativo === false;
                  const detalhesStatus = [
                    estaInativo && p.inativadoEm
                    ? `Inativado em: ${new Date(p.inativadoEm).toLocaleString('pt-BR')}`
                    : `Inativação programada para: ${
                        p.inatividadeAgendadaEm
                          ? new Date(p.inatividadeAgendadaEm).toLocaleString('pt-BR')
                          : ''
                      }`,
                    p.reativacaoAgendadaPara
                      ? `Reativação em: ${new Date(p.reativacaoAgendadaPara).toLocaleString('pt-BR')}`
                      : null,
                    p.motivoInativacao ? `Motivo: ${p.motivoInativacao}` : null
                  ].filter(Boolean).join('\n');
                  const currentRegiao = getDisplayValue(p, 'regiao');
                  const currentRegiaoId = typeof currentRegiao === 'object' ? currentRegiao?._id : currentRegiao;
                  
                  const currentCoordenadores = getDisplayValue(p, 'coordenadores') || [];
                  
                  return (
                    <tr key={p._id}>
                      <Td>
                        <Input 
                          value={getDisplayValue(p, 'nome')} 
                          onChange={(e) => handleChange(p._id, 'nome', e.target.value)}
                        />
                      </Td>
                      <Td>
                        <Input 
                          value={getDisplayValue(p, 'local')} 
                          onChange={(e) => handleChange(p._id, 'local', e.target.value)}
                        />
                      </Td>
                      <Td>
                        <MultiSelectContainer>
                          {['Manhã', 'Tarde', 'Noite'].map(periodo => (
                            <label key={periodo} style={{display:'flex', alignItems:'center', fontSize:'11px', marginRight:'4px'}}>
                              <input 
                                type="checkbox" 
                                checked={(getDisplayValue(p, 'periodos') || []).includes(periodo)}
                                onChange={() => toggleArrayItem(p._id, 'periodos', periodo)}
                              />
                              {periodo}
                            </label>
                          ))}
                        </MultiSelectContainer>
                      </Td>
                      <Td>
                        <FaixasEditor
                          faixas={getDisplayValue(p, 'intervalosDeHorario') || []}
                          onChange={(lista) => handleChange(p._id, 'intervalosDeHorario', lista)}
                        />
                      </Td>
                      <Td>
                        <MultiSelectContainer>
                          {['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab', 'Dom'].map(dia => (
                            <label key={dia} style={{display:'flex', alignItems:'center', fontSize:'11px', marginRight:'4px'}}>
                              <input 
                                type="checkbox" 
                                checked={(getDisplayValue(p, 'dias') || []).includes(dia)}
                                onChange={() => toggleArrayItem(p._id, 'dias', dia)}
                              />
                              {dia}
                            </label>
                          ))}
                        </MultiSelectContainer>
                      </Td>
                      <Td>
                        <Select 
                          value={currentRegiaoId || ''} 
                          onChange={(e) => handleChange(p._id, 'regiao', e.target.value)}
                        >
                          <option value="">Selecione</option>
                          {regioes.map(r => (
                            <option key={r._id} value={r._id}>{r.nome}</option>
                          ))}
                        </Select>
                      </Td>
                      <Td>
                        <SearchableUserList 
                          users={usuarios.filter(u => u.perfil && u.perfil.includes('coordenador-ponto'))}
                          selectedIds={currentCoordenadores}
                          onToggle={(userId) => toggleArrayItem(p._id, 'coordenadores', userId)}
                          placeholder="Buscar coord..."
                        />
                      </Td>
                      <Td>
                        <SearchableUserList 
                          users={usuarios.filter(u => u.perfil && u.perfil.includes('coordenador-regional'))}
                          selectedIds={currentCoordenadores}
                          onToggle={(userId) => toggleArrayItem(p._id, 'coordenadores', userId)}
                          placeholder="Buscar regional..."
                        />
                      </Td>
                      <Td>
                        <SearchableUserList 
                          users={usuarios.filter(u => u.perfil && u.perfil.includes('secretaria'))}
                          selectedIds={currentCoordenadores}
                          onToggle={(userId) => toggleArrayItem(p._id, 'coordenadores', userId)}
                          placeholder="Buscar secretária..."
                        />
                      </Td>
                      <Td>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                          <ActionButton 
                            disabled={!isEdited} 
                            onClick={() => handleSave(p._id)}
                          >
                            Salvar
                          </ActionButton>
                          {isEdited && (
                            <CancelButton onClick={() => handleCancel(p._id)}>
                              Cancelar
                            </CancelButton>
                          )}

                          {isEdited && !estaInativo && !temInativacaoAgendada && (
                            <div
                              style={{
                                borderTop: '1px solid #ddd',
                                marginTop: '5px',
                                paddingTop: '8px '
                              }}
                            />
                          )}
                          
                          {(estaInativo || temInativacaoAgendada) && (
                            <>
                              <StatusBadge 
                                $scheduled={temInativacaoAgendada && !estaInativo}
                                title={detalhesStatus}
                                aria-label={detalhesStatus}
                              >
                                {estaInativo ? 'Inativado' : 'Inativação agendada'}
                              </StatusBadge>

                              <ActionButton onClick={() => setPontoSelecionadoParaAcao(p)}>
                                {estaInativo ? 'Reativar' : 'Cancelar agendamento'}
                              </ActionButton>
                            </>
                  )}

                  {!estaInativo && !temInativacaoAgendada && (
                    <ActionButton onClick={() => handleAbrirModalInativacao(p)}>
                      Inativar
                    </ActionButton>
                  )}
                        </div>
                      </Td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </TableWrapper>
        </Container>
      </MainContentWrapper>
      {showCreateModal && (
        <ModalOverlay onClick={() => setShowCreateModal(false)}>
          <ModalContent onClick={e => e.stopPropagation()}>
            <ModalHeader>
              <ModalTitle>Criar Novo Ponto</ModalTitle>
              <CloseButton onClick={() => setShowCreateModal(false)}>&times;</CloseButton>
            </ModalHeader>
            
            <FormGroup>
              <Label>Nome *</Label>
              <Input 
                value={newPonto.nome} 
                onChange={e => setNewPonto({...newPonto, nome: e.target.value})}
                placeholder="Nome do Ponto"
              />
            </FormGroup>

            <FormGroup>
              <Label>Local *</Label>
              <Input 
                value={newPonto.local} 
                onChange={e => setNewPonto({...newPonto, local: e.target.value})}
                placeholder="Endereço/Local"
              />
            </FormGroup>

            <FormGroup>
              <Label>Região *</Label>
              <Select 
                value={newPonto.regiao} 
                onChange={e => setNewPonto({...newPonto, regiao: e.target.value})}
              >
                <option value="">Selecione a Região</option>
                {regioes.map(r => (
                  <option key={r._id} value={r._id}>{r.nome}</option>
                ))}
              </Select>
            </FormGroup>

            <FormGroup>
              <Label>Períodos</Label>
              <MultiSelectContainer>
                {['Manhã', 'Tarde', 'Noite'].map(periodo => (
                  <label key={periodo} style={{display:'flex', alignItems:'center', fontSize:'13px', marginRight:'10px'}}>
                    <input 
                      type="checkbox" 
                      checked={newPonto.periodos.includes(periodo)}
                      onChange={() => toggleNewPontoArrayItem('periodos', periodo)}
                    />
                    {periodo}
                  </label>
                ))}
              </MultiSelectContainer>
            </FormGroup>

            <FormGroup>
              <Label>Horários</Label>
              <FaixasEditor
                faixas={newPonto.intervalosDeHorario}
                onChange={(lista) => setNewPonto(prev => ({ ...prev, intervalosDeHorario: lista }))}
              />
            </FormGroup>

            <FormGroup>
              <Label>Dias da Semana</Label>
              <MultiSelectContainer>
                {['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab', 'Dom'].map(dia => (
                  <label key={dia} style={{display:'flex', alignItems:'center', fontSize:'13px', marginRight:'10px'}}>
                    <input 
                      type="checkbox" 
                      checked={newPonto.dias.includes(dia)}
                      onChange={() => toggleNewPontoArrayItem('dias', dia)}
                    />
                    {dia}
                  </label>
                ))}
              </MultiSelectContainer>
            </FormGroup>

            <div style={{ display: 'flex', gap: '10px' }}>
              <FormGroup style={{ flex: 1 }}>
                <Label>Coordenadores de Ponto</Label>
                <SearchableUserList 
                  users={usuarios.filter(u => u.perfil && u.perfil.includes('coordenador-ponto'))}
                  selectedIds={newPonto.coordenadores}
                  onToggle={(userId) => toggleNewPontoArrayItem('coordenadores', userId)}
                  placeholder="Buscar coordenador..."
                />
              </FormGroup>

              <FormGroup style={{ flex: 1 }}>
                <Label>Coordenador Regional</Label>
                <SearchableUserList 
                  users={usuarios.filter(u => u.perfil && u.perfil.includes('coordenador-regional'))}
                  selectedIds={newPonto.coordenadores}
                  onToggle={(userId) => toggleNewPontoArrayItem('coordenadores', userId)}
                  placeholder="Buscar regional..."
                />
              </FormGroup>

              <FormGroup style={{ flex: 1 }}>
                <Label>Secretárias</Label>
                <SearchableUserList 
                  users={usuarios.filter(u => u.perfil && u.perfil.includes('secretaria'))}
                  selectedIds={newPonto.coordenadores}
                  onToggle={(userId) => toggleNewPontoArrayItem('coordenadores', userId)}
                  placeholder="Buscar secretária..."
                />
              </FormGroup>
            </div>

            <div style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
              <ActionButton onClick={handleCreatePonto}>Criar Ponto</ActionButton>
              <CancelButton onClick={() => setShowCreateModal(false)}>Cancelar</CancelButton>
            </div>

          </ModalContent>
        </ModalOverlay>
      )}
      {pontoSelecionadoParaInativar &&
        etapaModalInativacao === 'configuracao' && (
          <ModalOverlay onClick={handleFecharModalInativacao}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
              <ModalHeader>
                <ModalTitle>
                  Inativar ponto: {pontoSelecionadoParaInativar.nome} 
                </ModalTitle>
                <CloseButton onClick={handleFecharModalInativacao}>
                  &times;
                </CloseButton>
              </ModalHeader>

              <FormGroup>
                <ModalQuestion>
                  Quando o ponto deve ser inativado?
                </ModalQuestion>

                <RadioOption>
                  <input
                    type="radio"
                    name="tipoInativacao"
                    checked={tipoInativacao === 'imediata'}
                    onChange={() => setTipoInativacao('imediata')}
                  />
                  Imediatamente
                </RadioOption>

                <RadioOption>
                  <input
                    type="radio"
                    name="tipoInativacao"
                    checked={tipoInativacao === 'agendada'}
                    onChange={() => setTipoInativacao('agendada')}
                  />
                  Agendar inativação 
                </RadioOption> 
              </FormGroup>

              {tipoInativacao === 'agendada' && (
                <FormGroup>
                  <Label>Data e horário da inativação</Label>
                  <Input
                    type="datetime-local"
                    value={dataInativacao}
                    onChange={(e) => setDataInativacao(e.target.value)}
                 />
               </FormGroup>
              )}

              {tipoInativacao && (
                <FormGroup>
                <ModalQuestion>
                  Deseja agendar data de reativação?
                  <HelperText>
                    {' '} (Se necessário, o ponto poderá ser reativado manualmente depois)
                  </HelperText>
                </ModalQuestion>
                
                <RadioOption>
                  <input
                    type="radio"
                    name="agendarReativacao"
                    checked={agendarReativacao === true }
                    onChange={() => setAgendarReativacao(true)}
                  />
                  Sim
                </RadioOption>

                <RadioOption>
                  <input
                    type="radio"
                    name="agendarReativacao"
                    checked={agendarReativacao === false}
                    onChange={() => setAgendarReativacao(false)}
                  />
                  Não
                </RadioOption>
              </FormGroup>
            )}  
                
            {agendarReativacao === true && (
              <FormGroup>
                <Label>Data e horário da reativação</Label>
                <Input
                  type="datetime-local"
                  value={dataReativacao}
                  onChange={(e) => setDataReativacao(e.target.value)}
                />  
              </FormGroup>
            )}

            <FormGroup>
              <ModalQuestion> Motivo da inativação</ModalQuestion>
              <Input
                as="textarea"
                rows={3}
                value={motivoInativacao}
                onChange={(e) => setMotivoInativacao(e.target.value)}
              />
            </FormGroup>

            <div style={{ display: 'flex', gap: '10px' }}>
              <ActionButton
                onClick={() => setEtapaModalInativacao('confirmacao')}
                disabled={
                  !tipoInativacao ||
                  agendarReativacao === null ||
                  (tipoInativacao === 'agendada' && !dataInativacao) ||
                  (agendarReativacao === true && !dataReativacao) ||
                  !motivoInativacao.trim()
                }
              >
                Continuar
              </ActionButton> 


              <CancelButton onClick={handleFecharModalInativacao}>
                Cancelar
              </CancelButton>
            </div>
          </ModalContent>
        </ModalOverlay>
      )}
      {pontoSelecionadoParaInativar &&
        etapaModalInativacao === 'confirmacao' && (
          <ModalOverlay onClick={handleFecharModalInativacao}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
              <ModalHeader>
                <ModalTitle> Confirmar inativação </ModalTitle>
                <CloseButton onClick={handleFecharModalInativacao}>
                  &times;
                </CloseButton>
              </ModalHeader>

              <FormGroup>
                <SummaryDetails>
                  <p>
                    <strong>Ponto:</strong> {' '}
                    {pontoSelecionadoParaInativar.nome}
                  </p>

                  <p>
                   <strong> Inativação: </strong> {' '}
                   {tipoInativacao === 'imediata'
                     ? 'Imediatamente após a confirmação'
                     : new Date(dataInativacao).toLocaleString('pt-BR')}
                  </p>

                  {agendarReativacao && (
                    <p>
                      <strong>Reativação:</strong> {' '}
                      {new Date(dataReativacao).toLocaleString('pt-BR')}
                    </p>
                  )}

                  <p>
                    <strong>Motivo:</strong> {' '}
                    {motivoInativacao}
                  </p>
                </SummaryDetails>

                <ModalQuestion style={{ marginTop: '20px' }}>
                  Deseja confirmar a inativação deste ponto?
                </ModalQuestion>
              </FormGroup>

              <div style={{ display: 'flex', gap: '10px' }}>
                <ActionButton onClick={handleConfirmarInativacao}>
                  Sim, confirmar
                </ActionButton>

                <CancelButton onClick={handleFecharModalInativacao}>
                  Não, cancelar
                </CancelButton>
              </div>
            </ModalContent>
          </ModalOverlay>
      )}
      {pontoSelecionadoParaAcao && (
        <ModalOverlay onClick={() => setPontoSelecionadoParaAcao(null)}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <ModalTitle>
                {pontoSelecionadoParaAcao.ativo === false
                  ? 'Confirmar reativação'
                  : 'Cancelar inativação agendada'}
              </ModalTitle>
              <CloseButton onClick={() => setPontoSelecionadoParaAcao(null)}>
                &times;
              </CloseButton>
            </ModalHeader>

            <p>
              {pontoSelecionadoParaAcao.ativo === false
                ?`Deseja realmente reativar o ponto ${pontoSelecionadoParaAcao.nome}?`
                : `Deseja realmente cancelar o agendamento de inativação do ponto ${pontoSelecionadoParaAcao.nome}?`}
            </p>

            <div style={{ display: 'flex', gap: '10px'}}>
              <ActionButton onClick={handleConfirmarAcaoPonto}>
                Sim, confirmar
              </ActionButton>

              <CancelButton onClick={() => setPontoSelecionadoParaAcao(null)}>
                Não, cancelar
              </CancelButton>
            </div>
          </ModalContent>
        </ModalOverlay>
      )}
    </PageWrapper>
  );
};

export default GerenciarPontos;
